/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum UrgencyLevel {
    BLOCKING = 'blocking',
    IMPORTANT = 'important',
    LOW = 'low',
}
